import React, { useState, useMemo } from 'react';
import { Polyline, InfoWindow } from '@react-google-maps/api';
import { Typography } from '@mui/material';

function formatLocalTime(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr.endsWith('Z') ? dateStr : dateStr + 'Z');
  return d.toLocaleTimeString();
}

function getMidpoint(p1, p2) {
  return {
    lat: (p1.lat + p2.lat) / 2,
    lng: (p1.lng + p2.lng) / 2,
  };
}

const ARROW_EVERY_N = 15;

const baseOptions = {
  strokeColor: '#FFFF00',
  strokeOpacity: 0.9,
  strokeWeight: 5,
  zIndex: 1,
};

function getArrowIcon() {
  return {
    icon: {
      path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      strokeColor: 'rgb(254, 220, 86, 1)',
      fillColor: 'rgb(254, 220, 86, 1)',
      fillOpacity: 1,
    },
    offset: '100%',
  };
}

export default function RouteOverlay({ routes }) {
  const [hovered, setHovered] = useState(null);
  const arrowIcon = useMemo(() => getArrowIcon(), []);

  const segments = useMemo(() => {
    const result = [];
    let globalIdx = 0;
    routes.forEach((route) => {
      for (let i = 0; i < route.length - 1; i++) {
        result.push({
          path: [route[i], route[i + 1]],
          start: route[i],
          end: route[i + 1],
          eventDateUtc: route[i].eventDateUtc,
          showArrow: globalIdx % ARROW_EVERY_N === 0,
        });
        globalIdx++;
      }
    });
    return result;
  }, [routes]);

  return (
    <>
      {segments.map((seg, idx) => (
        <Polyline
          key={idx}
          path={seg.path}
          options={seg.showArrow ? { ...baseOptions, icons: [arrowIcon] } : baseOptions}
          onMouseOver={() => setHovered({ idx, seg })}
          onMouseOut={() => setHovered(null)}
        />
      ))}
      {hovered && hovered.seg.eventDateUtc && (
        <InfoWindow
          position={getMidpoint(hovered.seg.start, hovered.seg.end)}
          options={{ disableAutoPan: true, closeBoxURL: '' }}
        >
          <div style={{ textAlign: 'center' }}>
            <Typography variant="body1">
              {formatLocalTime(hovered.seg.eventDateUtc)}
            </Typography>
          </div>
        </InfoWindow>
      )}
      <style>
        {`
          .gm-ui-hover-effect {
            display: none !important;
          }
        `}
      </style>
    </>
  );
}